import Vue from 'vue';
import XLSX from 'xlsx';
import { i18n } from '@/plugins/i18n';
import { setColumnSize } from '@/utils/sheets';

/**
 * Defining all of the different rating types possible, the IDs are also defined in RatingController.php
 * @param {string} id : Id of the functinnality, 7 is the global rating
 * @param {string} name : Link of the page the user left, to prompt the rating modal
 */

// List of the functionnalities :
export const ratingIds = {
  PROBLEM_CREATION_ID: 1,
  INDICATOR_INPUT_ID: 2,
  ACTION_CREATION_ID: 3,
  MEETING_CREATION_ID: 4,
  MEETING_LEAD_ID: 5,
  GEMBA_WALK_LEAD_ID: 6,
  GLOBAL_ID: 7,
  INFORMATION_CLARITY_ID: 8,
  INDICATOR_MANAGEMENT_ID: 9,
  PROBLEM_MANAGEMENT_ID: 10,
  ACTION_MANAGEMENT_ID: 11,
  CONFIGURABLE_PAGE_CREATION_ID: 12,
};

const ratingTypes = [
  // ID 1 is triggered in problem-reporting
  // ID 2 is triggered in indicator-input
  // ID 3 is triggered in action-creation
  // ID 4 is triggered in settings/meetings
  // ID 5 is triggered in meeting-navigator
  // ID 6 is triggered in ongoing
  // ID 7 is the global rating modal
  // ID 8 is triggered in information-creation
  {
    name: '/it-indicators',
    id: ratingIds.INDICATOR_MANAGEMENT_ID,
  },
  {
    name: '/it-problems',
    id: ratingIds.PROBLEM_MANAGEMENT_ID,
  },
  {
    name: '/it-actions',
    id: ratingIds.ACTION_MANAGEMENT_ID,
  },
  {
    name: '/configurable-page',
    id: ratingIds.CONFIGURABLE_PAGE_CREATION_ID,
  },
];

/** Checking what page is currently active to return the right page name, id and message */
export function checkRatingInfosFromPage(page) {
  const getPage = ratingTypes.find(element => page.path.includes(element.name));
  if (getPage) {
    // Checking if the user came from an editable configurable page
    if (getPage.id === ratingIds.CONFIGURABLE_PAGE_CREATION_ID && !page.query.editable) {
      return false;
    }
    getPage.message = i18n.t(`message.RATING_MESSAGE_${getPage.id}`);
    return getPage;
  }
}

/** Exporting all of the ratings into a Excel document */
export function exportRatingsToExcel(ratings) {
  const dateFormat = i18n.t('dateFormat');
  const ratingColumns = [
    i18n.t('message.TEAM'),
    i18n.t('message.USER'),
    i18n.t('message.CREATION_DATE'),
    i18n.t('message.TYPE'),
    i18n.t('message.RATE'),
    i18n.t('message.COMMENTS'),
  ];
  const allTypes = [...new Set(ratings.map(e => e.type))];
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: i18n.t('message.RATINGS'),
    Subject: i18n.t('message.RATINGS'),
    CreateDate: Vue.moment().format(dateFormat),
  };

  allTypes.forEach((typeItem) => {
    const ratingRows = [ratingColumns];
    ratings.filter(rateItem => rateItem.type === typeItem).forEach((rateItem) => {
      const {
        type,
        team,
        rate,
        created,
        user,
        comment,
      } = rateItem;

      ratingRows.push([
        team,
        user,
        created,
        i18n.t(`message.RATING_${type}`),
        rate,
        comment,
      ]);
    });
    const ratingSheet = XLSX.utils.aoa_to_sheet(ratingRows);
    setColumnSize(ratingSheet, 20);
    XLSX.utils.book_append_sheet(wb, ratingSheet, i18n.t(`message.RATING_${typeItem}`).substr(0, 25));
  });

  XLSX.writeFile(wb, `${i18n.t('message.RATINGS')}_Shizen_${Vue.moment().format(i18n.t('lFullDateFormat'))}.xlsx`);
}

export default {
  ratingIds,
  checkRatingInfosFromPage,
  exportRatingsToExcel,
};
